export const config = {
  title: "Shelton Electrical Services LLC",
  meta: {
    description:
      "Shelton Electrical Services LLC offers expert residential, commercial, and industrial electrical solutions in Fort Worth, TX. Serving the community for over 25 years.",
    keywords: [
      "Shelton Electrical Fort Worth",
      "Residential Electrician Fort Worth",
      "Commercial Electrical Services",
      "Industrial Electrician TX"
    ],
    author: "Shelton Electrical Services LLC",
    canonicalUrl: "https://sheltonelectricalservice.com/",
  },
  sections: {
    header: { businessName: "Shelton Electrical Services LLC" },
    sectionB: {
      heroTitle: "Shelton Electrical Services",
      heroSubtitle: "Expert Electrical Solutions in Fort Worth, TX",
      learnAboutText: "Learn About Our Services",
      phoneNumber: "2146806945",
      phoneLabel: "(214) 680‑6945",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1409304338/photo/electricity-and-electrical-maintenance-service-engineer-hand-holding-ac-multimeter-checking.jpg?s=612x612&w=0&k=20&c=Pj3gqobTp67aPN8l-lm6q-uT2DDnm-aeFk7Gkvmbaok=",
      cardData: [
        { title: "Residential Electrical", description: "Wiring, outlets, lighting, home services for safety & convenience." },
        { title: "Commercial & Industrial", description: "Reliable electrical work for offices, retail, and industrial spaces." },
        { title: "Free Estimates", description: "25+ years serving Fort Worth, with free estimates & discounts for military & seniors." }
      ],
      description:
        "Shelton Electrical Services has been proudly serving Fort Worth for over 25 years, offering licensed, insured, and professional electrical solutions. We provide free estimates and 15% discounts for military members and seniors.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription: "Residential, commercial, and industrial electrical services tailored to your needs.",
      cards: [
        { title: "Wiring & Rewiring", description: "Complete wiring services for new installs and upgrades.", imageSrc: "https://media.istockphoto.com/id/2063084313/photo/technician-is-checking-air-conditioner-refrigerant-system-maintenance-and-check-switch-board.jpg?s=612x612&w=0&k=20&c=f6y5Ge5y3Tie31YwQ3UZUeQiF3h1_Sff65qONXKIgwA=", imageAlt: "Electrical Wiring" },
        { title: "Lighting & Outlets", description: "Installation and repair of lights, switches, and outlets.", imageSrc: "https://media.istockphoto.com/id/1264922001/photo/female-finger-is-turn-off-on-lighting-switch.jpg?s=612x612&w=0&k=20&c=fiIt8KpCXcYGVAoZJnRRfEv9oNWoAAEeVWq99xCU68E=", imageAlt: "Lighting Services" },
        { title: "Panel Upgrades", description: "Service panel upgrades to support modern electrical loads.", imageSrc: "https://media.istockphoto.com/id/495289342/photo/electrician-testing-voltage.jpg?s=612x612&w=0&k=20&c=MVi3E0I715ewSSpGMZizTx-qgkxxdoEoZwb2joS3LI4=", imageAlt: "Panel Upgrade" }
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Ceiling Fan Installation",
        "EV Charger Installation",
        "Electrical Troubleshooting",
        "Industrial Equipment Wiring"
      ],
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://sheltonelectricalservice.com/wp-content/uploads/2025/06/Electrical-Installations-For-Homes-And-Businesses.jpg",
        alt: "Shelton Electrical Services Team"
      },
      aboutText: [
        "Shelton Electrical Services LLC is a licensed and insured company with over 25 years of experience serving Fort Worth, TX.",
        "We pride ourselves on delivering professional, reliable electrical solutions for residential, commercial, and industrial clients."
      ],
    },
    sectionE: {
      profileImage: "https://sheltonelectricalservice.com/wp-content/uploads/2025/02/unnamed-22-copy.png",
      profileAlt: "Shelton Electrical Services Logo",
      businessName: "Shelton Electrical Services LLC",
      contact: {
        phone: "2146806945",
        phoneLabel: "(214) 680‑6945",
        email: "info.sheltonelectric@gmail.com",
        website: "https://sheltonelectricalservice.com/",
        address: "6865 Chickering Rd #440, Fort Worth, TX 76116"
      },
      socialMedia: {
        facebook: null,
        instagram: "https://www.instagram.com/shelton_electric/",
        twitter: null,
        linkedin: null,
        youtube: null
      },
    },
    sectionF: {
      address: "6865 Chickering Rd #440, Fort Worth, TX 76116",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3342.123456789!2d-97.3467890!3d32.7456789!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x865c29bd1234567f%3A0xabcdef7890123456!2s6865%20Chickering%20Rd%20%23440%2C%20Fort%20Worth%2C%20TX%2076116!5e0!3m2!1sen!2sus!4v1718601234567!5m2!1sen!2sus"
    }
  }
};

export default config;
